<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { inject } from 'vue'
import { cn } from '@ds/lib/utils'
import { INPUT_GROUP_SIZE } from '.'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const groupSize = inject(INPUT_GROUP_SIZE)

const TEXT_SIZE_CLASS = {
  sm: 'text-[11px]',
  md: 'text-xs',
  lg: 'text-sm',
} as const
</script>

<template>
  <span
    :class="cn(
      'text-muted-foreground flex items-center gap-2 pr-2 font-medium [&_svg]:pointer-events-none [&_svg]:size-4',
      TEXT_SIZE_CLASS[groupSize ?? 'md'],
      props.class,
    )"
  >
    <slot />
  </span>
</template>
